import { Dict } from "../../src/types/dict.js";
import { closeDialog, dialog, openDialog, popInHashPrefix } from "./dialog_popin.js";
import {ExtendedWindow} from "./head.js";

document.addEventListener("submit", (e) => {
	const form = (<HTMLElement>e.target).closest<HTMLFormElement>('form#login-form');
	if (!form) return;

	try {
		(<ExtendedWindow>window).plausible('account_register_form_submit');
	} catch(e) {
		console.error(e);
	}

	const formData = new FormData(form),
		email = formData.get('email'),
		remember = formData.get('remember');

	if (remember && typeof email === 'string') {
		localStorage.setItem("savedEmail", email);
	}
});

if (document.body.classList.contains('page-login') || document.body.classList.contains('page-register')) {
	const savedEmail = localStorage.getItem("savedEmail");
	if (savedEmail !== null) {
		const emailInput = document.querySelector<HTMLInputElement>("input#email");
		if (emailInput) {
			emailInput.value = savedEmail;
		}
	}

	document.addEventListener('click', function onSubmitRequested(e) {
		const el = (<HTMLElement>e.target).closest<HTMLButtonElement>('button[type="submit"]');
		if (!el) return;
		setTimeout(() => {
			el.disabled = true;
		});

		try {
			(<ExtendedWindow>window).plausible('account_register_form_submitBtn');
		} catch(e) {
			console.error(e);
		}
		setTimeout(() => {
			el.disabled = false;
		}, 1000);
	});
}
const widget = document.querySelector("#cap");
if (widget) {
	widget.addEventListener("solve", function (e) {
		const inputValidation = document.querySelector<HTMLInputElement>('#cap-checkbox-validation');
		if (inputValidation) {
			inputValidation.checked = true;
		}
	});
}
class A4iValidatePassword extends HTMLElement {
	#input: HTMLInputElement;
	#meter: HTMLElement | null | undefined;
	#label: HTMLElement | null | undefined;
	constructor() {
		super();
		this.#init();
	}
	#init() {
		const input = this.querySelector<HTMLInputElement>(this.dataset.inputSel ?? "input#password");
		if (input) {
			this.#input = input;
		} else {
			throw new Error('Missing #input element')
		}

		this.#input.addEventListener("input", () => {
			this.validate();
		});

		if (this.#input.value) {
			this.validate();
		}
	}
	validate() {
		const meter = this.#meter ?? this.querySelector<HTMLElement>("#pw-meter");
		if (meter) {
			this.#meter = meter;
		} else {
			throw new Error('Missing #meter element');
		}

		const label = this.#label ?? this.querySelector<HTMLElement>(".pw-strength");
		if (label) {
			this.#label = label;
		} else {
			throw new Error('Missing #label element');
		}

		const value = this.#input.value;
		const rules = Object.fromEntries(
			Array.from(document.querySelectorAll<HTMLElement>("#pw-rules > li[id]"))
				.map<[string, HTMLElement]>(input => [input.id, input])
				.values()
		);

		const status: Dict<boolean> = {
			rule_length: value.length >= 12,
			rule_lower: /[a-z]/.test(value),
			rule_upper: /[A-Z]/.test(value),
			rule_number: /\d/.test(value),
			rule_special: /[!@#$%^&*()_+}{';'?>.<,]/.test(value),
			rule_whitespace: value.length > 0 && !/\s/.test(value),
		};

		let score = 0;
		for (const [key, value] of Object.entries(status)) {
			if (value) score++;
			if (key in rules) {
				rules[key].classList.toggle("valid", value);
				rules[key].classList.toggle("invalid", !value);
			}
		}

		const nbValidations = Object.keys(status).length;

		const scale = (score / nbValidations).toFixed(2);
		this.#meter.ariaValueNow = score.toString();
		this.#meter.ariaValueText = `${score}/5`;
		this.#meter.dataset.label = `${score}/5`;
		this.#meter.style.setProperty("--scale", scale);

		this.#input.setCustomValidity(score === nbValidations ? '' : "Le mot de passe doit contenir au moins 12 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.");
	}
}
customElements.define('a4i-validate-password', A4iValidatePassword);

class A4iValidatePasswordConfirm extends HTMLElement {
	#input: HTMLInputElement;
	#inputConfirm: HTMLInputElement;
	constructor() {
		super();
		this.#init();
	}
	#init() {
		const input = document.querySelector<HTMLInputElement>(this.dataset.inputSel ?? "input#password");
		if (input) {
			this.#input = input;
		} else {
			throw new Error('Missing #input element')
		}

		const inputConfirm = this.querySelector<HTMLInputElement>(this.dataset.inputSel ?? "input#confirm_password");
		if (inputConfirm) {
			this.#inputConfirm = inputConfirm;
		} else {
			throw new Error('Missing ##inputConfirm element')
		}

		this.#inputConfirm.addEventListener("input", () => {
			this.validate();
		});

		if (this.#inputConfirm.value) {
			this.validate();
		}
	}

	validate() {
		this.#inputConfirm.setCustomValidity(this.#input.value === this.#inputConfirm.value ? '' : 'Les mots de passe ne correspondent pas.');
	}
}
customElements.define('a4i-validate-password-confirm', A4iValidatePasswordConfirm);

window.addEventListener('hashchange', openTarget);
setTimeout(() => openTarget());

/**
 * Fonction pour ouvrir les details hash
 * @param e
 */
async function openTarget(e?: HashChangeEvent) {
	const hash = location.hash.substring(1);


	let oldHash: string | null = null;
	if (e) {
		try {
			const url = new URL(e.oldURL);
			oldHash = url.hash.substring(1);
		} catch (e) {
			console.error(e);
		}
		console.debug('Hash change', !oldHash ? '(empty)' : oldHash, '=>', !hash ? '(empty)' : hash);
	}



	if (popInHashPrefix.test(hash)) {
		openDialog((hash.startsWith('_') ? '_' : '') + hash.replace(popInHashPrefix, ''))
			.catch(console.error);
		return;
	} else if (oldHash && popInHashPrefix.test(oldHash) && dialog.open) {
		console.debug('popin close');
		const promise = waitPopinClose();
		closeDialog();
		await promise;
	}

	if (!hash) {
		console.debug('[openTarget] no hash');
		return;
	}
}

// noinspection DuplicatedCode
function waitPopinClose() {
	return new Promise<void>(resolve => {
		if (!dialog.open) {
			resolve()
			return;
		}

		let timer: ReturnType<typeof setTimeout> = setTimeout(() => {
			resolve();
		}, 1000);

		document.body.addEventListener('popinclose', function onPopinClose() {
			clearTimeout(timer);
			document.body.removeEventListener('popinclose', onPopinClose);
			setTimeout(() => {
				resolve();
			});
		});
	});
}

